import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import {DataGrid, GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import {getDbConfigurationList,updateDbConigure,deleteDbConigure} from '../../services/user.service'
import * as CryptoJS from "crypto-js";
//import {deleteDbConigure} from "../../services/asset.service";

Date.prototype.dbFormatedDate = function () {

    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    return year + '-' + month + '-' + day;
    //return `${this.getFullYear()}-${this.getMonth()+1}-${this.getDate()-1}`
}

function getFormatedDate(dateString) {
    if (dateString !== null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return year + '-' + month + '-' + day;
        //return `${dte.getFullYear()}-${dte.getMonth()+1}-${dte.getDate()}`;
    } else {
        return null;
    }
}



function DbConfigureList() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    const columns = [

        {"field": "company_name",  "hide": false, "headerName": "Company name", "width": 250},
        {"field": "db_host",  "hide": false, "headerName": "Host Name", "width": 130},
        {"field": "db_name",  "hide": false, "headerName": "Database Name", "width": 200},
        {"field": "db_user",  "hide": false, "headerName": "Database User Name", "width": 130},
        {
            "field": "db_pass",  
            "hide": false, 
            "headerName": "Database Password", 
            "width": 130,
            renderCell: (params) => {
                return <span>{'*'.repeat(8)}</span>;
            }
        },
        {"field": "db_port",  "hide": false, "headerName": "Database Port", "width": 130},
        {
            field: 'status', 
            headerName: 'Status', 
            width: 100,
            renderCell: (params) => {
                const isActive = params.row.status === 1;
                return (
                    <span className={`badge ${isActive ? 'bg-success' : 'bg-secondary'}`}>
                        {isActive ? 'Active' : 'Inactive'}
                    </span>
                );
            }
        },
        {
            field: 'actions', 
            headerName: 'Actions', 
            width: 200, 
            renderCell: (params) => {
                const isActive = params.row.status === 1;
                return (
                    <span>
                        <button
                            type="button"
                            className={`btn btn-sm ml-2 ${isActive ? 'btn-warning' : 'btn-success'}`}
                            onClick={() => handleUpdatestatus(params.row.id, params.row.status)}
                        >
                            {isActive ? 'Deactivate' : 'Activate'}
                        </button> &nbsp;
                        <button
                            type="button"
                            className="btn btn-danger btn-sm ml-2"
                            onClick={() => handleDeleteClick(params.row.id)}
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    </span>
                );
            }
        }
    ];

    const handleDeleteClick = (costId) => {
        //alert(costId);
        //console.log(`Deleting cost center with ID: ${costId}`);
        const confirmDelete = window.confirm("Are you sure you want to delete this database config ?");
        if (confirmDelete) {
            //encrypted data
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': {'configId': costId},
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = {'token': EncryptData}
            deleteDbConigure(oData).then(function (res) {
                //console.log(res);
                if ((typeof (res.data.errors) != "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    getDbConfigurationList(oData);
                    //window.location.reload();
                }
            });
        } else {
            window.location.reload();
        }
    };
    const handleUpdatestatus = (costId, currentStatus) => {
        const newStatus = currentStatus === 1 ? 0 : 1;
        const statusText = newStatus === 1 ? 'activate' : 'deactivate';
        
        const confirmUpdate = window.confirm(`Are you sure you want to ${statusText} this database config?`);
        if (confirmUpdate) {
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': {'configId': costId, status: newStatus},
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = {'token': EncryptData}
            
            updateDbConigure(oData).then(function (res) {
                if ((typeof (res.data.errors) != "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    window.location.reload();
                }
            });
        }
    };

    useEffect(() => {
        //encrypted data
        let EncryptData = CryptoJS.AES.encrypt(
            JSON.stringify({
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }),
            process.env.REACT_APP_ENCRYPT_SECRET_KEY
        ).toString();
        let oData = { 'token': EncryptData };

        setLoading(true);

        getDbConfigurationList(oData)
            .then((res) => {
                if (res?.data?.data?.length) setItems(res.data.data);
                setSuccess(true);
            })
            .catch((error) => {
                setErrMsg(error.message);
                setSuccess(false);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const CustomToolbar = () => (
        <GridToolbarContainer>
            <GridToolbarExport />
        </GridToolbarContainer>
    );

    return (
        <div className='container1'>
            <div className='row'>
                <div className='col-md-6'>
                    <h5>DB Configuration List</h5>
                </div>
            </div>

            {loading ? (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <DataGrid
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                    rows={items}
                    getRowId={(row) => row.company_id}
                    columns={columns}
                    pageSize={50}
                    autoHeight
                    rowsPerPageOptions={[50]}
                />
            )}


        </div>
    );
}

export default DbConfigureList
